var _defs, _circle, _circle2, _path, _path2, _path3, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0aadd6;}.cls-2{fill:none;stroke:#2f2d3b;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-3{fill:#e6e7e8;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32,
    cy: 27,
    r: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 32,
    cy: 27,
    r: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.83,35.35c.32,.71,.46,1.52,.31,2.37l-2.84,15.64c-.17,.95-1,1.64-1.97,1.64h-8.66s-.02,0-.03,0l.07,.36c.17,.95,1,1.64,1.97,1.64h8.66c.97,0,1.79-.69,1.97-1.64l2.84-15.64c.34-1.88-.69-3.64-2.31-4.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.64,44l2.06,11.36c.17,.95,1,1.64,1.97,1.64h8.66c.97,0,1.8-.69,1.97-1.64l2.84-15.64c.45-2.46-1.44-4.72-3.93-4.72h-10.42c-2.49,0-4.38,2.26-3.93,4.72l.05,.28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36,35v1c0,2.21-1.79,4-4,4s-4-1.79-4-4v-1h8Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 52.79,
    cy: 15,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 52.79,
    cy: 15,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.63,23.35c.32,.71,.46,1.52,.31,2.37l-2.84,15.64c-.17,.95-1,1.64-1.97,1.64h-8.66s-.02,0-.03,0l.07,.36c.17,.95,1,1.64,1.97,1.64h8.66c.97,0,1.79-.69,1.97-1.64l2.84-15.64c.34-1.88-.69-3.64-2.31-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.43,32l2.06,11.36c.17,.95,1,1.64,1.97,1.64h8.66c.97,0,1.8-.69,1.97-1.64l2.84-15.64c.45-2.46-1.44-4.72-3.93-4.72h-10.42c-2.49,0-4.38,2.26-3.93,4.72l.05,.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.79,23v1c0,2.21-1.79,4-4,4s-4-1.79-4-4v-1h8Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.21,
    cy: 15,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 11.21,
    cy: 15,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.04,23.35c.32,.71,.46,1.52,.31,2.37l-2.84,15.64c-.17,.95-1,1.64-1.97,1.64H4.88s-.02,0-.03,0l.07,.36c.17,.95,1,1.64,1.97,1.64H15.54c.97,0,1.79-.69,1.97-1.64l2.84-15.64c.34-1.88-.69-3.64-2.31-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.85,32l2.06,11.36c.17,.95,1,1.64,1.97,1.64H15.54c.97,0,1.8-.69,1.97-1.64l2.84-15.64c.45-2.46-1.44-4.72-3.93-4.72H6c-2.49,0-4.38,2.26-3.93,4.72l.05,.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.21,23v1c0,2.21-1.79,4-4,4s-4-1.79-4-4v-1H15.21Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperts);
export default __webpack_public_path__ + "static/media/experts.4a17f4526b399bf61e7a5ff4bb496705.svg";
export { ForwardRef as ReactComponent };